module.exports = __webpack_public_path__ + "static/img/fitPlanBan.0c89eac.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/fitPlanBan.png
// module id = dK2C
// module chunks = 1